import { useContext } from 'react'
import { AuthorizationContext } from '../contexts'

export function usePermissions () {
  const permissions = useContext(AuthorizationContext)

  return permissions
}
